// @ts-check

/**
 * @typedef {object} LanguageConfig
 * @property {string} defaultLanguage
 * @property {readonly string[]} allowedLanguages
 */

/** @type {Record<import('./brand-by-target.mjs').Brand, LanguageConfig>} */
export const LANGUAGE_CONFIG = {
  lm: {
    defaultLanguage: 'ru',
    allowedLanguages: ['ru'],
  },
  ph: {
    defaultLanguage: 'en',
    allowedLanguages: ['en', 'tl'],
  },
  ph2: {
    defaultLanguage: 'en',
    allowedLanguages: ['en', 'tl'],
  },
  pw: {
    defaultLanguage: 'en',
    allowedLanguages: ['en', 'ru', 'uk', 'de', 'ro', 'tl'],
  },
};

/** @type {string[]} */
export const ALL_LANGUAGES = Array.from(
  new Set(
    Object.values(LANGUAGE_CONFIG).flatMap((config) => config.allowedLanguages)
  )
);
